import $ from 'jquery';
import debounce from './utils/debounce';
import PerfectScrollbar from 'perfect-scrollbar';

class Table {
    constructor () {
        this.$window = $(window);
        this.$tableWrapper = $('.js-table-wrapper');
        this.$tableInnerClass = '.js-table__inner';
        this.$window.on('resize', debounce(() => {
            this.updateScrollbars();
        }));

        // Scrollbar init
        this.tableScrollbars = [];
        this.addScrollbars();
    }

    /* #Scrollbar functions
    ================================================== */
    addScrollbars () {
        this.$tableWrapper.each((index, element) => {
            const $table = $(element).find(this.$tableInnerClass);
            this.tableScrollbars.push(new PerfectScrollbar($table[0], {
                scrollXMarginOffset: 60,
                scrollYMarginOffset: 60
            }));
        });
    }

    destroyScrollbars () {
        this.tableScrollbars.forEach((ps) => ps.destroy());
    }

    updateScrollbars () {
        this.tableScrollbars.forEach((ps) => ps.update());
    }
}

export default Table;
